// //final

// import React, { useState } from 'react';
// import axios from 'axios';
// import Env from '../runtimeEnv';

// function NicknameForm({ currentNickname, setCurrentNickname, onNicknameSubmit, PlutonicuserID, onClose }) {
//   const [nickname, setNickname] = useState(currentNickname || '');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleNicknameSubmit = async (nicknameToSet) => {
//     if (!nicknameToSet.trim()) {
//       setError('Nickname cannot be empty.');
//       return;
//     }
//     if (!PlutonicuserID) {
//       setError('Missing user ID. Please log in again.');
//       console.error('[NicknameForm] Missing PlutonicuserID in request.');
//       return;
//     }

//     console.log('[NicknameForm] Submitting payload:', { PlutonicuserID, newNickname: nicknameToSet });

//     setLoading(true);
//     setError('');

//     try {
//       console.log('API URL being used:', Env.REACT_APP_PYTHON_API_URL);
//       console.log(PlutonicuserID,nicknameToSet )
//       console.log(localStorage.getItem('access_token'))
//       const response = await axios.put(
//         `${Env.REACT_APP_PYTHON_API_URL}/api/update-nickname`,
//         { PlutonicuserID, newNickname: nicknameToSet },
//         {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json',
//             // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         console.log('Nickname updated successfully:', nicknameToSet);

//         // Update state and localStorage
//         setCurrentNickname(nicknameToSet);
//         localStorage.setItem('currentNickname', nicknameToSet); // Persist the updated nickname
//         onNicknameSubmit(nicknameToSet); // Notify parent component
//         onClose(); // Close the form after successful update
//       } else {
//         setError('Failed to update nickname.');
//       }
//     } catch (err) {
//       console.error('Error updating nickname:', err);
//       console.log('API URL:', Env.REACT_APP_PYTHON_API_URL);

//       setError(
//         err.response?.data?.error || 'An error occurred while updating the nickname. Please try again.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleNicknameSubmit(nickname);
//   };

//   return (
//     <div className="bg-black p-8 rounded-3xl shadow-lg w-[350px] text-white text-center relative">
//       {/* Close Button */}
//       {/* Close Button with Cross Symbol */}
//       <button
//         className="absolute top-2 p-2 right-2 text-white text-2xl font-bold hover:text-gray-400"
//         onClick={onClose} // Trigger the parent-provided onClose
//       >
//         &times;
//       </button>

//       <h2 className="text-2xl font-bold mb-6">Update Nickname</h2>
//       <form onSubmit={handleSubmit} className="space-y-2">
//         <div className="relative">
//           <input
//             type="text"
//             value={nickname}
//             onChange={(e) => setNickname(e.target.value)}
//             placeholder="Enter your nickname"
//             className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
//             required
//           />
//         </div>
//         {error && <p className="text-red-500">{error}</p>}
//         <button
//           type="submit"
//           className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
//           disabled={loading}
//         >
//           {loading ? 'Updating...' : 'Submit'}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default NicknameForm;


import React, { useState } from 'react';
import axiosInstance from '../api/axiosInstance'; // ✅ Import axiosInstance

function NicknameForm({ currentNickname, setCurrentNickname, onNicknameSubmit, PlutonicuserID, onClose }) {
  const [nickname, setNickname] = useState(currentNickname || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNicknameSubmit = async (nicknameToSet) => {
    if (!nicknameToSet.trim()) {
      setError('Nickname cannot be empty.');
      return;
    }
    if (!PlutonicuserID) {
      setError('Missing user ID. Please log in again.');
      console.error('[NicknameForm] Missing PlutonicuserID in request.');
      return;
    }



    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.put(
        `/api/update-nickname`,
        { PlutonicuserID, newNickname: nicknameToSet }
      );

      if (response.status === 200) {


        // ✅ Update state and localStorage
        setCurrentNickname(nicknameToSet);
        localStorage.setItem('currentNickname', nicknameToSet);
        onNicknameSubmit(nicknameToSet);
        onClose(); // Close the form after successful update
      } else {
        setError('Failed to update nickname.');
      }
    } catch (err) {
      console.error("Error updating nickname:");
      setError(
        err.response?.data?.error || 'An error occurred while updating the nickname. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleNicknameSubmit(nickname);
  };

  return (
    <div className="bg-black p-8 rounded-3xl shadow-lg w-[350px] text-white text-center relative">
      {/* Close Button */}
      <button
        className="absolute top-2 p-2 right-2 text-white text-2xl font-bold hover:text-gray-400"
        onClick={onClose}
      >
        &times;
      </button>

      <h2 className="text-2xl font-bold mb-6">Update Nickname</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        <div className="relative">
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="Enter your nickname"
            className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
            required
          />
        </div>
        {error && <p className="text-red-500">{error}</p>}
        <button
          type="submit"
          className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
          disabled={loading}
        >
          {loading ? 'Updating...' : 'Submit'}
        </button>
      </form>
    </div>
  );
}

export default NicknameForm;
